<!-- =========================================================================================
    File Name: TodoEdit.vue
    Description: Edit todo component
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <vs-prompt
        title="Edit Task"
        :accept-text="popupText"
        cancel-text = "Cancel"
        button-cancel = "border"
        :color="popupText.includes('Complete') ? 'success':'danger' "
        @cancel="cancelTodo"
        @accept="popupText.includes('Complete') ? completeTodo(): removeComplete()"
        @close="init"
        :is-valid="validateForm"
        :active.sync="activePrompt">
        <div>
            <form>
                <div class="vx-row">
                    <div class="vx-col w-full">
                        <vs-input :disabled="true" v-validate="'required'" name="title" class="w-full mb-4 mt-5" placeholder="Title" v-model="taskLocal.title" />
                        <vs-textarea :disabled="true" rows="5" label="Description" v-model="taskLocal.description" />
                        <vs-chip v-for="(tag, index) in taskLocal.tags" :key="index">
                          <div class="icondiv" :class="tag.text =='Low' ? 'low' : tag.text =='Medium' ? 'medium': 'high' " ></div>
                          <span>{{ tag.text | capitalize }}</span>
                        </vs-chip>
                    </div>
                </div>

            </form>
        </div>
    </vs-prompt>
</template>




<script>
export default {
  props: {
    displayPrompt: {
      type: Boolean,
      required: true
    },
    taskId: {
      type: Number,
      required: true
    },
    taskLocal:{
      type:Object,
      required: true
    },
    completedList:{
      type:Array,
      required:true
    },
  },
  data () {
    return {
      popupText:"",
    }
  },
  computed: {
    activePrompt: {
      get () {
        return this.displayPrompt
      },
      set (value) {
        this.$emit('hideDisplayPrompt', value)
      }
    },
    validateForm () {
      return !this.errors.any() && this.taskLocal.title !== ''
    }
  },
  methods: {
    cancelTodo () {
      this.displayPrompt = false;
      document.getElementById("menuIcon").style.display = 'inline-flex';
    },
    init () {
      document.getElementById("menuIcon").style.display = 'inline-flex';
    },
    removeComplete(){
      this.$emit('removeComplete');
      document.getElementById("menuIcon").style.display = 'inline-flex';
    },
    completeTodo () {
      this.completedList;
      this.$emit('completeHomeworkItem');
      document.getElementById("menuIcon").style.display = 'inline-flex';
    }
  },
  created(){
    var self = this;
    self.popupText ="Complete";
    self.completedList.forEach(element => {
      if(self.taskLocal.id == element.homeworkBookItemId)
      {
        self.popupText ="Uncomplete";
      }
    });
    
  },
  
}
</script>

<style lang="scss">
  footer{
    button[type="border"]{
      background: transparent;
      border: 1px solid;
      color: rgba(0, 0, 0, 0.5);
      border-color: rgba(0, 0, 0, .2) !important;
      cursor: pointer;
    }

    button[type="filled"]{
      background: rgba(var(--vs-success),1)!important;
      border: 1px solid;
      color: rgba(0, 0, 0, 0.5);
      cursor: pointer;
    }

  }
</style>
